'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _contants = require('./contants');

var _nodeTypes = require('./node-types');

var _tokenizer = require('./tokenizer');

var _tokenizer2 = _interopRequireDefault(_tokenizer);

var _parser = require('./parser');

var _parser2 = _interopRequireDefault(_parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  getName: function getName(node) {
    var nodeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
    return node[nodeKey];
  },
  getChildren: function getChildren(node) {
    var nodeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
    return node[nodeKey];
  }
};

function traverse(selectors, tree, treeKey, options) {
  var selector = selectors[0];

  var expressionType = selector.type;
  switch (expressionType) {
    case _contants.SELECTOR_EXPRESSION_DESCENDANT:
      return (0, _nodeTypes.DescendantExpressionNode)(traverse, selectors, tree, treeKey, options);
    case _contants.SELECTOR_EXPRESSION_CHILD:
      return (0, _nodeTypes.ChildExpressNode)(traverse, selectors, tree, treeKey, options);
    case _contants.SELECTOR_EXPRESSION_ROOT:
      return (0, _nodeTypes.RootExpressionNode)(traverse, selectors, tree, treeKey, options);
    default:
      throw new Error('Could not match expression type to a node type.');
  }
}

function req(name) {
  throw new Error('Required param: \'' + name + '\'');
}

function evaluate() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : req('selector');
  var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : req('tree');
  var options = arguments[2];

  options = (0, _assign2.default)({}, defaultOptions, options || {});
  var ast = (0, _parser2.default)((0, _tokenizer2.default)(selector));
  return traverse(ast.selectors, tree, undefined, options);
}

exports.default = evaluate;